// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1ssb{width:50%}\n._1e0c1txw{display:flex}\n._1pbyni7l{z-index:600}\n._2hwxu2gc{margin-right:var(--ds-space-100,8px)}\n._2lx2vrvc{flex-direction:row}", ""]);
// Exports
module.exports = exports;
